// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorizedHeaderContent_container__32V0o"};